module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-white text-md md:text-xl mb-3 md:mb-4",
    attrs: {
      "id": "step-template"
    }
  }, [_c('div', {
    staticClass: "text-2xl md:text-3xl p-3 pb-0 md:p-6 md:pb-0 inline-block cursor-pointer"
  }, [_vm._t("back")], 2), _vm._v(" "), _c('div', {
    staticClass: "p-3 md:p-6 mr-0"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13c98886","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/step-template.vue
// module id = 166
// module chunks = 0